'use client';

import * as TooltipPrimitive from 'radix-ui/tooltip';

export type TooltipProviderProps = React.ComponentProps<typeof TooltipPrimitive.Provider>;

export const TooltipProvider: React.FC<TooltipProviderProps> = ({ delayDuration = 0, ...props }) => (
  <TooltipPrimitive.Provider data-spellbook-name="tooltip-provider" delayDuration={delayDuration} {...props} />
);
